import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
import './AvatarView.css';
export const AvatarView = ({ enabled, videoStream, onToggle, }) => {
    const videoRef = useRef(null);
    useEffect(() => {
        if (videoRef.current && videoStream) {
            videoRef.current.srcObject = videoStream;
        }
    }, [videoStream]);
    if (!enabled) {
        return (_jsx("div", { className: "avatar-view disabled", children: _jsx("button", { onClick: onToggle, className: "enable-avatar-button", "aria-label": "Enable avatar", children: "Enable Avatar" }) }));
    }
    return (_jsxs("div", { className: "avatar-view", role: "region", "aria-label": "Avatar video", children: [_jsx("video", { ref: videoRef, autoPlay: true, playsInline: true, muted: true, className: "avatar-video", "aria-label": "Virtual Banker avatar" }), _jsx("button", { onClick: onToggle, className: "avatar-toggle", "aria-label": "Hide avatar", children: "\u2715" })] }));
};
